import { render, staticRenderFns } from "./BaseCalender.vue?vue&type=template&id=4ed0f860&"
import script from "./BaseCalender.vue?vue&type=script&lang=js&"
export * from "./BaseCalender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports